import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import ProgressBar from "../../../../components/uiComponent/progressBar";

const RowData = ({ data = [] }) => {

  const [columnDefs] = useState([
    {
      headerName: "Shipment ID",
      headerClass: "shipment_id",
      cellClass: "shipment_cell_id",
      field: "amazon_shipment_confirmation_id",
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true
    },
    {
      headerName: "FC ID",
      headerClass: "shipment_id",
      cellClass: "shipment_cell_id",
      field: "amazon_warehouse_id",
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 100
    },
    {
      headerName: "Progress",
      headerClass: "shipment_id",
      cellClass: "shipment_cell_id",
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 100,
      cellRenderer: ({ data }) => {
        let total = 0;
        let current = 0;
        data?.shipment_items_info?.forEach(item => {
          total += Number(item.quantity) || 0;
          current += Number(item.boxed_quantity) || 0;
        });
        let status = 'grey';

        if (current === 0) {
          status = 'grey'
          // total = 0
        }
        else if (total === current) status = 'success'
        else if (current < total) status = 'warning'
        else status = 'warning'
        return (
          <ProgressBar className="inner-pro-br" status={status} simpleProgress total={total} current={current} />
        )
      }
    },
  ]);

  return (
    <div className="ag-theme-alpine" style={{ height: 'auto', width: "100%" }}>
      <AgGridReact
        rowData={data?.shipments || []}
        columnDefs={columnDefs}
        pagination={false}
        paginationPageSize={null}
        rowHeight={36}
        headerHeight={24}
        domLayout="autoHeight"
        className="inner-pro-table-progress"
      />
    </div>
  );
};

export default RowData;
